module.exports = __webpack_public_path__ + "static/1-asset-3-d-c7034e8f6e69c556eb1bfedfae202e45.png";